// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createAuditSummary} from '../../shared/repositories';
import {getAuditSummaryReportCriteria} from '../../shared/services/reports';

export const createAuditSummaryReport = () =>
    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const auditSummaryCriteria = getState().reports.auditSummary.criteria;

            const postArgs = getAuditSummaryReportCriteria(auditSummaryCriteria);

            const data = await createAuditSummary(postArgs);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_AUDIT_SUMMARY_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetAuditSummaryReport = () => ({
    type: actions.RESET_AUDIT_SUMMARY_REPORT
});



// WEBPACK FOOTER //
// ./src/reports/audit-summary/action-creators/report.js